/**
 * @desc form - switch
 * @author Kody
 */
import React from 'react';
import { classSet } from '@umu/umu-dom';
import { SwitchNum } from '@umu/umu-types';

export type valueType = SwitchNum;
type sizeType = 'small' | 'middle' | 'big';

interface IProps {
    value: valueType;
    size?: sizeType;
    bgColor?: string;
    isDisabled?: boolean;
    onChange(nextValue: valueType): void;
}
const DEFAULT_BG = '#FFAB00';

import './switch.scss';

export const Switch = (props: IProps) => {
    const { value, size = 'middle', bgColor = DEFAULT_BG, isDisabled = false, onChange } = props;
    const onChangeHandle = () => {
        if (!isDisabled) {
            onChange(value === 1 ? 0 : 1);
        }
    };
    const render = () => {
        const isOn = value.toString() === '1';
        const switchClass = classSet({
            [size]: true,
            'switch': true,
            'is-disabled': isDisabled,
        });
        const handleClass = classSet({
            'handle': true,
            'is-on': isOn,
        });
        return (
            <div className={switchClass} onClick={onChangeHandle} style={{ backgroundColor: isOn ? bgColor : '#ccc' }}>
                <div className={handleClass} />
            </div>
        );
    };
    return render();
};
